import { IListing, IListingRating, IReservation, ISubPhoto } from '../interfaces';
import { Rating } from './rating';
import { User } from './user';

export class ListingRating extends Rating implements IListingRating {
  rated?: IListing;
  ratedId?: number;
  reservation?: IReservation;
  reservationId?: number;
  hidden?: boolean;
  adminHidden?: boolean;
  adminHiddenReason?: string | null;
  adminHiddenById?: number | null;
  adminHiddenAt?: string | Date | null;
  photos?: ISubPhoto[];

  constructor(data?: IListingRating) {
    super(data);

    if (data) {
      this.setData(data);
    }
  }

  override setData(data: IListingRating): void {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any)[key] = (data as any)[key];
      }
    }

    if (this.creator) {
      this.creator = new User(this.creator);
    }
  }
}
